import React from 'react';
import ProductPatternPage from './ProductPatternPage';
import './BhendiPage.css';
import bhendiLogo from '../images/bhendi.png';
import akshita225 from '../images/bhindi-akshita-225-img.png';
import arya702 from '../images/bhendi-arya-702-img.png';
import agraja from '../images/bhendi-Agraja-img.png';
import dsAbhiram from '../images/bhendi-DS-Abhiram-img.png';
import agni505 from '../images/bhendi-agni-505-img.png';

const varieties = [
  {
    name: 'AGRAJA',
    image: agraja,
    description: [
      'F1 hybrid bhendi with excellent fruit quality',
      'Maturity: 42-45 days after sowing',
      'Plant habit: Tall, vigorous plant',
      'Internode: Medium long',
      'Fruit color: Very dark green',
      'Fruit length: 14-16 cm',
      'Tolerance: Intermediate resistance (IR) to YVMV and ELCV',
      'Suitable for long-distance transport',
    ],
  },
  {
    name: 'ARYA-702',
    image: arya702,
    description: [
      'F1 hybrid bhendi with excellent fruit quality',
      'Maturity: 43-48 days after sowing',
      'Plant habit: Tall, vigorous plant',
      'Internode: Medium long',
      'Fruit color: Very dark green',
      'Fruit length: 14-16 cm',
      'Tolerance: Intermediate resistance (IR) to YVMV and ELCV',
      'Suitable for long-distance transport',
      'Good export potential',
    ],
  },
  {
    name: 'AKSHITA-225',
    image: akshita225,
    description: [
      'Versatile hybrid okra variety ideal for year-round cultivation',
      'Robust growth and long shelf life for better marketability',
      'Plant growth: Medium height with 2-4 branches',
      'Fruits are dark green, densely clustered, and soft in texture',
      'Fruit length: 12-14 cm',
      'Fruit width: 1.5-1.8 cm',
      'First harvest: 45-50 days',
      'Medium tolerance to YVMV and ELCV',
      'Consistent fruit size suitable for fresh use and market sales',
    ],
  },
  {
    name: 'DS-ABHIRAM',
    image: dsAbhiram,
    description: [
      'Hybrid okra seed with very prolific and early bearing habit',
      'Physical appearance: Good tolerance to heat and disease',
      'Foliage: Medium-sized oblong to heart-shaped leaves with serrated edges and fine bristles',
      'Fruit appearance: Attractive shiny green pods, 14-15 cm length and 1.5-2 cm diameter',
      'Growing condition: Performs best in well-drained sandy loam rich in organic matter',
      'Use case: Suitable for balcony and terrace gardening',
      'Growth requirement: Water daily and maintain full sunlight exposure',
      'Best season: October to June',
      'Maturity: 45-50 days after transplanting',
    ],
  },
  {
    name: 'AGNI-505',
    image: agni505,
    description: [
      'Tall and vigorous hybrid okra with medium cut leaves',
      'Fruit shape and colour: Shiny dark green fruits with excellent quality',
      'Tolerance: YVMV and ELCV',
      'Yield potential: High with prolonged harvesting',
      'Market value: High due to quality and uniformity',
      'Recommended season: Kharif and Summer',
      'Reduced losses due to strong viral disease tolerance',
    ],
  },
  
];

export default function BhendiPage() {
  return <ProductPatternPage title="Bhendi" varieties={varieties} pageClass="bhendi-page" heroImage={bhendiLogo} />;
}
